import { render, staticRenderFns } from "./ShipmentsPrint.vue?vue&type=template&id=fb9b7d30&scoped=true"
import script from "./ShipmentsPrint.vue?vue&type=script&lang=js"
export * from "./ShipmentsPrint.vue?vue&type=script&lang=js"
import style0 from "./ShipmentsPrint.vue?vue&type=style&index=0&id=fb9b7d30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9b7d30",
  null
  
)

export default component.exports